import React from 'react';
import QuestionWrapper from '../response/QuestionWrapper';
import ConnectedTimed from './ConnectedTimed';

const TimedQuestion = props => {
  return (
    <QuestionWrapper {...props}>
      <ConnectedTimed {...props} />
    </QuestionWrapper>
  )
}

export default TimedQuestion;